"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Td_1 = require("./Td");
exports.default = Td_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/components/Td/index.js
// module id = 551
// module chunks = 8